import { useMemo } from 'react'

import { useCheckedIds } from 'app/common/templates-next/table-template'

type HasId = {
  id: string
}

export const useDishesWithTechCard = <T extends HasId>(dishes: ReadonlyArray<T>) => {
  const checkedDishesIds = useCheckedIds()

  const res = useMemo(() => {
    const checkedDishesSet = new Set(checkedDishesIds)
    return dishes.filter(({ id }) => checkedDishesSet.has(id)) // TODO добавить проверку на наличие техкарты
  }, [checkedDishesIds, dishes])

  return res
}
